module.exports = __webpack_public_path__ + "img/38.8e9e1fca.jpg";